// In development, derive the API host from the browser's own hostname so the
// app works both on localhost and when accessed from another device on LAN.
const devApiBase = (() => {
    if (process.env.REACT_APP_API_BASE_URL) return process.env.REACT_APP_API_BASE_URL;
    if (process.env.NODE_ENV === "development") {
        return `http://${window.location.hostname}:8000/api`;
    }
    return "http://localhost:8000/api";
})();

export const API_CONFIG = {
    BASE_URL: devApiBase,
    ENDPOINTS: {
        // Authentication
        AUTH: {
            REGISTER: "/auth/register",
            LOGIN: "/auth/access-token",
            REFRESH: "/auth/refresh-token",
            FORGOT_PASSWORD: "/auth/forgot-password",
            RESET_PASSWORD: "/auth/reset-password",
        },
        // Products
        PRODUCTS: {
            BASE: "/products",
            CATEGORIES: "/categories",
            BRANDS: "/brands",
            SEARCH: "/products/search",
            STOCK: "/products/stock",
            STOCK_MOVEMENTS: "/products/stock/movements",
        },
        // Customers
        CUSTOMERS: {
            BASE: "/customers",
            SEARCH: "/customers/search",
            BY_EMAIL: "/customers/email",
            ADDRESSES: "/customers/{id}/addresses",
            ADDRESS_DETAIL: "/customers/addresses/{id}",
            ADDRESS_SET_DEFAULT: "/customers/addresses/{id}/set-default",
        },
        // Customer pet profiles
        PETS: {
            BY_CUSTOMER: "/customers/{id}/pets",
            DETAIL: "/customers/pets/{id}",
            PHOTO: "/customers/pets/{id}/photo",
        },
        // Orders
        ORDERS: {
            BASE: "/orders",
            BY_CUSTOMER: "/orders/customer",
            BY_STATUS: "/orders/status",
            RECENT: "/orders/recent",
            SUMMARY: "/orders/summary",
            CANCEL: "/orders/{id}/cancel",
            ITEMS: "/orders/{id}/items",
        },
        // Suppliers
        SUPPLIERS: {
            BASE: "/suppliers",
            SEARCH: "/suppliers/search",
        },
        // Inventory
        INVENTORY: {
            BASE: "/inventory",
            LOW_STOCK: "/inventory/low-stock",
        },
        // Guest Order Requests (e-commerce checkout)
        GUEST_ORDERS: {
            BASE: "/guest-orders",
            APPROVE: "/guest-orders/{id}/approve",
            REJECT: "/guest-orders/{id}/reject",
            LINK_ORDER: "/guest-orders/{id}/link-order",
            IDS: "/guest-orders/ids",
            BULK_DELETE: "/guest-orders/bulk-delete",
            BKASH_RECHECK: "/guest-orders/{id}/bkash/recheck",
        },
        // Contact Messages (storefront Contact page)
        CONTACT_MESSAGES: {
            BASE: "/contact-messages",
            STATUS: "/contact-messages/{id}/status",
        },
    },
    HEADERS: {
        "Content-Type": "application/json",
    },
    TIMEOUT: 10000,
};

export const getAuthHeader = (token: string) => ({
    Authorization: `Bearer ${token}`,
});

export const buildUrl = (endpoint: string, params?: Record<string, string>) => {
    let url = `${API_CONFIG.BASE_URL}${endpoint}`;

    if (params) {
        Object.keys(params).forEach((key) => {
            url = url.replace(`{${key}}`, params[key]);
        });
    }

    return url;
};
